import translate from '../core/tools/translate';
import CoreControl from './CoreControl';
import { VectorType } from './VectorType';

export class TollControl extends CoreControl {
    constructor () {
        super({ name: 'Toll' });

        this.select = this.select.bind(this);
    }

    static getInstance () {
        if (!TollControl._instance) {
            TollControl._instance = new TollControl();
        }

        return TollControl._instance;
    }

    init() {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-toll',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            type: 'vector-points'
        };

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    select (value) {
        this.getLayer().setOptions({
            remote: {
                params: {
                    id: value
                }
            }
        });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().redraw();
        }
    }
}

export default TollControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/TollControl.js